import {
  filterLinkedBrListItems,
  getBrSubmissionApprovalId,
  pickEffectiveBrItem,
  sortBrListItemsBySubmitTime,
} from './brList';
import {
  BR_STATUS,
  getItemStatusCode,
  isBrApprovedCode,
  isBrExpiredSoon,
  isBrPendingCode,
  isBrVerifiedItem,
} from './brStatus';

export function hasBrListSubmissionActivity(items) {
  const list = Array.isArray(items) ? items : [];
  return list.some((item) => {
    const code = getItemStatusCode(item);
    return isBrPendingCode(code)
      || isBrApprovedCode(code)
      || code === BR_STATUS.REJECTED;
  });
}

/** 公司是否具备至少一张可解锁执照（AccessGate 失败时的本地兜底） */
export function hasBrVerifiedDocument(items) {
  return (Array.isArray(items) ? items : []).some((item) => isBrVerifiedItem(item));
}

/** 最新提交：Submit Time 新→旧，同秒取 ApprovalId 更大者（避免双待弹时抖动） */
export function getLatestBrSubmission(items) {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) {
    return null;
  }
  return sortBrListItemsBySubmitTime(list)[0] || null;
}

export function isBrResultNotifyPending(item) {
  const raw = item?.brResultNotifyPending ?? item?.BrResultNotifyPending;
  return raw === true || raw === 1 || raw === '1';
}

/**
 * 结果弹窗候选（固定优先级队列，不比登录/提醒时间）：
 * · 只在「待弹」的 A/R 里选一笔；每次登录只弹队列最高的一款
 * · 优先序：已驳回 > 已通过（同优先级内再取最新提交）
 * · Q2-B：按 ApprovalId 各弹一次；关掉只 ack 这一笔，下次登录轮到下一款
 */
export function findBrResultNotificationTarget(items, nameChangeItems = []) {
  const list = [
    ...(Array.isArray(items) ? items : []),
    ...(Array.isArray(nameChangeItems) ? nameChangeItems : []),
  ];
  if (!list.length) {
    return null;
  }
  const pending = list.filter((item) => isBrResultNotifyPending(item));
  if (!pending.length) {
    return null;
  }

  const rejectedPending = pending.filter(
    (item) => getItemStatusCode(item) === BR_STATUS.REJECTED,
  );
  if (rejectedPending.length) {
    const latestRejected = getLatestBrSubmission(rejectedPending);
    return latestRejected ? { item: latestRejected, type: 'rejected' } : null;
  }

  const approvedPending = pending.filter(
    (item) => isBrApprovedCode(getItemStatusCode(item)),
  );
  if (approvedPending.length) {
    const latestApproved = getLatestBrSubmission(approvedPending);
    return latestApproved ? { item: latestApproved, type: 'approved' } : null;
  }

  return null;
}

export function hasBrRenewalInFlight(items) {
  return (items || []).some((item) => isBrPendingCode(getItemStatusCode(item)));
}

/**
 * 临期黄条 / 弹窗（产品规则）：
 * 1. 到期前约 30 天内
 * 2. 仅「已生效且当前公司展示名称」那张 BR
 * 3. 若已有审核中（P/PA）BR → 不提醒
 */
export function shouldShowBrListExpiredSoonBar(item, items, options = {}) {
  if (!isBrVerifiedItem(item) || !isBrExpiredSoon(item)) {
    return false;
  }
  const list = Array.isArray(items) ? items : [];
  if (hasBrRenewalInFlight(list)) {
    return false;
  }
  if (options.isCurrentDisplay === true) {
    return true;
  }
  const current = pickEffectiveBrItem(list);
  return !!(
    current
    && getBrSubmissionApprovalId(current) === getBrSubmissionApprovalId(item)
  );
}

export function findBrExpirySoonTarget(items) {
  const list = filterLinkedBrListItems(items);
  const current = pickEffectiveBrItem(list);
  if (!current) {
    return null;
  }
  if (!shouldShowBrListExpiredSoonBar(current, list, { isCurrentDisplay: true })) {
    return null;
  }
  return current;
}
